/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryRole } from '../../models/inventory-role';

export interface GetInventoryRoles$Params {
}

export function getInventoryRoles(http: HttpClient, rootUrl: string, params?: GetInventoryRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InventoryRole>>> {
  const rb = new RequestBuilder(rootUrl, getInventoryRoles.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InventoryRole>>;
    })
  );
}

getInventoryRoles.PATH = '/admin/inventories/roles';
